const raffSizes=["12","12.5","13","13.5","14","14/14.5","14.5","14.5/15","15","15/15.5","15.5","16","16.5","16.5/17","17","18","19"];
const raffRows={
"Neck Size (Collar Bottom)":[32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48],
"Chest Circumference":[72,76,80,84,88,92,96,100,104,108,112,116,120,124,128,132,136],
"Waist Circumference":[66,70,74,78,82,86,90,94,98,102,108,112,116,120,124,128,132],
"Hem Circumference":[72,76,80,84,88,92,96,100,104,108,112,116,120,124,128,132,136],
"Center Back Length":[64,64,66,66,68,68,70,72,74,74,76,76,80,80,82,82,84],
"Shoulder Width":[36.2,37.4,38.6,39.8,41,42.2,43.4,44.6,45.8,47,48.2,49.4,50.6,51.8,53,54.2,55.4],
"Sleeve Length":[55.5,55.5,57,57,58,59,60,60,61.5,62.5,64,64,65.5,65.5,67,67,67],
"Cuff Circumference":[21,22,22,23,23,24,24,24,25,25,26,26,26,27,27,27,28],
"Short Sleeve Length":[19,19.5,20,20.5,21,21.5,22,22.5,23,23.5,24,24.5,25,25,25.5,25.5,26],
"Short Sleeve Opening":[29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,null],
"Sleeve Width / Bicep":[32.1,33.3,34.5,35.7,36.9,38.1,39.3,40.5,41.7,42.9,44.1,45.3,46.5,47.7,48.9,50.1,51.3],
"1st Buttonhole to Collar Base":[5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5,5.5],
"Bottom Buttonhole to Hem":[13.8,13.8,14.2,14.2,14.6,14.6,15,15.4,15.8,15.8,16.2,16.2,16.6,16.6,17,17,17.4],
"Buttonhole Spacing":[7.47,7.43,7.7,7.65,7.92,7.88,8.15,8.43,8.7,8.65,8.93,8.88,9.15,9.11,9.38,9.34,9.61]
};
const camSizes=["32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54"];
const camRows={
"Collar (Upper Collar Base)":[32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54],
"Chest":[72,76,80,84,88,92,96,100,104,108,112,116,120,124,128,132,136,140,144,148,152,156,160],
"Waist":[66,70,74,78,82,86,90,94,98,102,108,112,116,120,124,128,132,136,140,144,148,152,156],
"Hem":[72,76,80,84,88,92,96,100,104,108,112,116,120,124,128,132,136,140,144,148,152,156,160],
"Back Center Length":[64,64,66,66,68,68,70,72,74,74,76,76,81,81,83,83,85,85,87,87,87,87,87],
"Shoulder Width":[37.2,38.2,39.4,40.6,41.8,43,44.2,45.4,46.6,47.8,49,50.2,51.4,52.6,53.8,55,56.2,57.4,58.6,59.8,61,62.2,63.4],
"Sleeve Length":[55.5,55.5,57,58,58,58,59,60,61.5,61.5,62.5,64,64,65.5,65.5,67,67,67,67,68,68,68,68],
"Cuff Width":[21,22,22,23,23,24,24,24,25,25,25,26,26,26,27,27,28,28,28,28,29,29,29],
"Sleeve Width":[32.1,33.3,34.5,35.7,36.9,38.1,39.3,40.5,41.7,42.9,44.1,45.3,46.5,47.7,48.9,50.1,51.3,52.5,53.7,54.9,56.1,57.3,58.5]
};
function buildTable(id,sizes,rows){
 const table=document.getElementById(id); if(!table)return;
 let html='<thead><tr><th>Measurement / Size</th>'+sizes.map(s=>`<th>${s}</th>`).join('')+'</tr></thead><tbody>';
 Object.entries(rows).forEach(([label,vals])=>{html+=`<tr><td>${label}</td>`+vals.map(v=>`<td>${v??'—'}</td>`).join('')+'</tr>'});
 table.innerHTML=html+'</tbody>';
}
function initGuides(){
 buildTable('raffinato-table',raffSizes,raffRows); buildTable('camicia-table',camSizes,camRows);
 document.querySelectorAll('.guide-tab').forEach(btn=>btn.addEventListener('click',()=>{
   document.querySelectorAll('.guide-tab').forEach(b=>b.classList.remove('active')); btn.classList.add('active');
   document.getElementById('raffinato-table').classList.toggle('hidden',btn.dataset.guide!=='raffinato');
   document.getElementById('camicia-table').classList.toggle('hidden',btn.dataset.guide!=='camicia');
 }));
}
document.addEventListener('DOMContentLoaded',initGuides);

/* ---- Shop by size: pick a collar size, see what it measures, then pick the shirt ---- */
const SF_ROWS = {
  camicia: { rows: camRows, keys: ["Collar (Upper Collar Base)","Chest","Back Center Length","Sleeve Length"] },
  raffinato: { rows: raffRows, keys: ["Neck Size (Collar Bottom)","Chest Circumference","Center Back Length","Sleeve Length"] }
};
const SF_LABELS = { 0:"Collar", 1:"Chest", 2:"Back length", 3:"Sleeve" };
const inches = cm => (Math.round((cm / 2.54) * 4) / 4).toString().replace(/\.0+$/, "");
const money = (cents, fmt) => {
  const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return fmt && fmt.indexOf("{{") > -1 ? fmt.replace(/\{\{\s*amount\s*\}\}/, amount) : "$" + amount;
};

function initSizeFirst(root) {
  const data = JSON.parse(document.getElementById("sf-data-" + root.dataset.section).textContent);
  const items = data.items || [];
  const chips = root.querySelector(".sf-chips");
  const pointer = root.querySelector(".sf-pointer");
  const panel = root.querySelector(".sf-panel");
  const empty = root.querySelector(".sf-empty");
  if (!items.length) { root.querySelector(".sf-chipwrap").hidden = true; return; }
  empty.hidden = true;

  const bySize = new Map();
  items.forEach(it => {
    const key = it.cm;
    if (!bySize.has(key)) bySize.set(key, { cm: key, inch: it.inch, items: [] });
    bySize.get(key).items.push(it);
  });
  const sizes = [...bySize.values()].sort((a, b) => parseFloat(a.cm) - parseFloat(b.cm));

  sizes.forEach(s => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "sf-chip";
    b.dataset.cm = s.cm;
    b.setAttribute("aria-pressed", "false");
    const any = s.items.some(i => i.available);
    if (!any) b.classList.add("is-out");
    b.innerHTML = `<span class="sf-in">${s.inch}</span><span class="sf-cm">${s.cm} cm</span>`;
    b.setAttribute("aria-label", `Collar ${s.inch}, ${s.cm} centimetres${any ? "" : ", not in stock online"}`);
    chips.appendChild(b);
  });

  // The chips wrap onto several rows, so the pointer has to follow the selected
  // chip on both axes or it ends up pointing at empty space below another row.
  function movePointer(btn) {
    // Measure against the pointer's own positioning context, not the chip list:
    // the label above the chips sits inside it and would offset every reading.
    const box = root.querySelector(".sf-chipwrap").getBoundingClientRect();
    const r = btn.getBoundingClientRect();
    const x = r.left - box.left + r.width / 2;
    const y = r.bottom - box.top + 6;
    pointer.style.transform = `translate(${x}px, ${y}px)`;
    pointer.classList.add("is-on");
  }

  function stats(cmValue, chart) {
    const spec = SF_ROWS[chart] || SF_ROWS.camicia;
    // The collar row holds the centimetre value for every column, in both charts,
    // so the column index is simply where that value sits in the collar row.
    const i = spec.rows[spec.keys[0]].indexOf(parseFloat(cmValue));
    if (i < 0) return [];
    return spec.keys.map((k, n) => {
      const v = spec.rows[k] && spec.rows[k][i];
      return v == null ? null : { label: SF_LABELS[n], cm: v, in: inches(v) };
    }).filter(Boolean);
  }

  function select(btn) {
    chips.querySelectorAll(".sf-chip").forEach(c => { c.classList.remove("is-on"); c.setAttribute("aria-pressed", "false"); });
    btn.classList.add("is-on"); btn.setAttribute("aria-pressed", "true");
    movePointer(btn);
    const size = bySize.get(btn.dataset.cm);

    root.querySelector(".sf-measure-title").textContent = `Collar ${size.inch} · ${size.cm} cm`;
    const dl = root.querySelector(".sf-stats");
    dl.innerHTML = stats(size.cm, size.items[0].chart)
      .map(s => `<div><dt>${s.label}</dt><dd>${s.cm} cm<span>${s.in} in</span></dd></div>`).join("");

    root.querySelector(".sf-shirts").innerHTML = size.items.map(it => `
      <article class="sf-shirt${it.available ? "" : " is-out"}">
        ${it.image ? `<img src="${it.image}" alt="${it.title}" loading="lazy" width="600" height="750">` : ""}
        <div class="sf-shirt-body">
          <p class="sf-fabric">${it.fabric}</p>
          <h4><a href="${it.url}">${it.title}</a></h4>
          <p class="sf-price">${money(it.price, data.money_format)}</p>
          ${it.available
            ? `<button type="button" class="btn btn-dark sf-add" data-vid="${it.vid}">Add this one</button>`
            : `<p class="sf-out-line">${data.sold_out_line}</p>`}
        </div>
      </article>`).join("");
    panel.hidden = false;
    root.querySelector(".sf-status").textContent = "";
  }

  chips.addEventListener("click", e => { const b = e.target.closest(".sf-chip"); if (b) select(b); });
  root.addEventListener("click", async e => {
    const add = e.target.closest(".sf-add"); if (!add) return;
    const status = root.querySelector(".sf-status");
    add.disabled = true; const original = add.textContent; add.textContent = "Adding…";
    try {
      const r = await fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.vid), quantity: 1 }] })
      });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || "That size could not be added."); }
      const cart = await (await fetch("/cart.js")).json();
      document.querySelectorAll("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; });
      status.innerHTML = `In your bag. <a class="text-link" href="${data.cart_url}">Go to the bag</a>`;
      add.textContent = "Added";
    } catch (err) {
      status.textContent = err.message;
      add.disabled = false; add.textContent = original;
    }
  });
  window.addEventListener("resize", () => { const on = chips.querySelector(".sf-chip.is-on"); if (on) movePointer(on); });
}
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".size-first").forEach(initSizeFirst);
});

/* ---- Alive: reveal on scroll ---- */
(function () {
  const calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const targets = document.querySelectorAll(".section-heading, .sf-head, .page-head, .film-copy, .film-frame, .fabric-card, .care-steps li, .faq-item, .showroom-copy, .showroom-note, .shirt-choice, .prod-card, .post-card, .hadur-trust-item, .promo-copy, .promo-image, .join-in, .hadur-about > div");
  if (calm || !("IntersectionObserver" in window)) { targets.forEach(t => t.classList.add("in")); return; }
  targets.forEach(t => t.classList.add("rv"));
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
  targets.forEach(t => io.observe(t));
})();

/* ---- Product page (2026-09-16): thumbnails, share, add to bag, buy now, the sticky bar ---- */
(function () {
  const page = document.querySelector("[data-product-page]");
  if (!page) return;
  const main = page.querySelector("[data-main]");
  page.querySelectorAll(".pp-thumb").forEach(t => t.addEventListener("click", () => {
    if (!main) return;
    page.querySelectorAll(".pp-thumb").forEach(x => { x.classList.remove("is-on"); x.setAttribute("aria-selected", "false"); });
    t.classList.add("is-on"); t.setAttribute("aria-selected", "true");
    main.classList.add("is-swapping");
    const img = new Image();
    img.onload = () => { main.removeAttribute("srcset"); main.src = t.dataset.full; main.alt = t.dataset.alt || main.alt; main.classList.remove("is-swapping"); };
    img.src = t.dataset.full;
  }));
  const share = page.querySelector("[data-share]");
  if (share) share.addEventListener("click", async () => {
    const data = { title: document.title, url: location.href };
    try { if (navigator.share) { await navigator.share(data); return; } } catch (_) { return; }
    try { await navigator.clipboard.writeText(location.href); share.title = "Link copied"; } catch (_) {}
  });
  const form = page.querySelector("[data-product-form]");
  const status = page.querySelector("[data-status]");
  const price = page.querySelector("[data-price]"), compare = page.querySelector("[data-compare]"), off = page.querySelector("[data-off]");
  const picked = page.querySelector("[data-picked]"), sPrice = page.querySelector("[data-sticky-price]"), sSize = page.querySelector("[data-sticky-size]");
  function chosen() { return form ? form.querySelector("input[name=id]:checked, input[name=id][type=hidden]") : null; }
  if (form) form.addEventListener("change", e => {
    const r = e.target.closest("input[name=id]"); if (!r) return;
    if (price && r.dataset.price) price.textContent = r.dataset.price;
    if (compare) { compare.textContent = r.dataset.compare || ""; compare.hidden = !r.dataset.compare; if (off) off.hidden = !r.dataset.compare; }
    if (picked) picked.textContent = "Collar " + (r.dataset.title || "");
    if (sPrice && r.dataset.price) sPrice.textContent = r.dataset.price;
    if (sSize) sSize.textContent = r.dataset.title || "";
    // real stock only: the line shows when the store itself holds 5 or fewer of this size
    const left = page.querySelector("[data-left-line]");
    if (left) { left.hidden = !r.dataset.left; left.querySelector("[data-left-n]").textContent = r.dataset.left || ""; }
  });
  async function add() {
    const r = chosen(); if (!r) throw new Error("Pick a size first.");
    const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: Number(r.value), quantity: 1 }] }) });
    if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || "That size could not be added."); }
    const cart = await (await fetch("/cart.js")).json();
    document.querySelectorAll("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
    return cart;
  }
  async function run(btn, label, then) {
    if (!btn || btn.disabled) return;
    const original = btn.textContent; btn.disabled = true; btn.textContent = label;
    try { await add(); await then(); } catch (err) { if (status) status.textContent = err.message; }
    finally { btn.disabled = false; btn.textContent = original; }
  }
  const addBtn = page.querySelector("[data-add]"), buyBtn = page.querySelector("[data-buy]"), stickyBtn = page.querySelector("[data-sticky-add]");
  const inBag = async () => { if (status) status.textContent = ""; if (window.hadurOpenBag) { await window.hadurOpenBag(); } else if (status) { status.innerHTML = 'In your bag. <a class="text-link" href="/cart">Go to the bag</a>'; } };
  if (form) form.addEventListener("submit", e => { e.preventDefault(); run(addBtn, "Adding…", inBag); });
  if (stickyBtn) stickyBtn.addEventListener("click", () => run(stickyBtn, "Adding…", inBag));
  if (buyBtn) buyBtn.addEventListener("click", () => run(buyBtn, "One moment…", async () => { location.href = "/checkout"; }));
  // the bar shows once the real buttons have scrolled away
  const sticky = page.querySelector("[data-sticky]");
  if (sticky && addBtn && "IntersectionObserver" in window) {
    sticky.hidden = false;
    new IntersectionObserver(entries => { entries.forEach(en => sticky.classList.toggle("is-on", !en.isIntersecting && en.boundingClientRect.top < 0)); }, { threshold: 0 }).observe(addBtn);
  }
})();

/* mobile menu: the header button opens the drawer under it */
(function(){var b=document.querySelector('.hadur-menu'),d=document.getElementById('hadur-drawer');if(!b||!d)return;
function set(o){d.hidden=!o;b.setAttribute('aria-expanded',o?'true':'false');b.textContent=o?'\u2715':'\u2630';document.documentElement.classList.toggle('hadur-drawer-open',o)}
b.addEventListener('click',function(){set(d.hidden)});
d.addEventListener('click',function(e){if(e.target.closest('a'))set(false)});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!d.hidden)set(false)});
window.addEventListener('resize',function(){if(innerWidth>800&&!d.hidden)set(false)});})();

/* product gallery dots on a phone (2026-10-08): the dot follows the picture in view */
(function () {
  const row = document.querySelector("[data-shots]"); if (!row || !("IntersectionObserver" in window)) return;
  const dots = document.querySelectorAll(".ss-dots i"), shots = row.querySelectorAll(".ss-shot");
  if (!dots.length) return;
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    const i = Array.prototype.indexOf.call(shots, e.target);
    dots.forEach((d, j) => d.classList.toggle("is-on", j === i));
  }), { root: row, threshold: 0.6 });
  shots.forEach(s => io.observe(s));
})();

/* "Buy both" (2026-10-08): the other shirt in the same collar size, or an honest "not in that size" */
(function () {
  const box = document.querySelector("[data-both]"); if (!box) return;
  const data = JSON.parse(box.querySelector("[data-both-data]").textContent);
  const btn = box.querySelector("[data-both-add]"), st = box.querySelector("[data-both-status]");
  const priceEl = box.querySelector("[data-both-price]"), sizeEl = box.querySelector("[data-both-size]");
  const fmt = c => (data.money || "${{amount}}").replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2));
  function current() { const r = document.querySelector("[data-product-form] input[name=id]:checked, [data-product-form] input[name=id][type=hidden]"); return r ? data.self.find(v => String(v.id) === r.value) : null; }
  function pair() { const me = current(); if (!me) return null; const o = data.other.find(v => v.t === me.t); return { me, o }; }
  function render() {
    const p = pair(); st.textContent = "";
    if (!p) { btn.disabled = true; return; }
    sizeEl.textContent = "Collar " + p.me.t;
    if (!p.o || !p.o.a || !p.me.a) { btn.disabled = true; st.textContent = "The " + data.otherName + " is not available in collar " + p.me.t + "."; priceEl.textContent = fmt(p.me.p); return; }
    btn.disabled = false; priceEl.textContent = fmt(p.me.p + p.o.p);
  }
  document.addEventListener("change", e => { if (e.target.matches("[data-product-form] input[name=id]")) render(); });
  btn.addEventListener("click", async () => {
    const p = pair(); if (!p || !p.o) return;
    const label = btn.textContent; btn.disabled = true; btn.textContent = "Adding…";
    try {
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: p.me.id, quantity: 1 }, { id: p.o.id, quantity: 1 }] }) });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || "Could not add both shirts.");
      const cart = await (await fetch("/cart.js")).json();
      document.querySelectorAll("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
      st.textContent = ""; if (window.hadurOpenBag) await window.hadurOpenBag(); else st.innerHTML = 'Both shirts are in your bag. <a class="text-link" href="/cart">Go to the bag</a>';
    } catch (err) { st.textContent = err.message; }
    finally { btn.textContent = label; btn.disabled = false; }
  });
  render();
})();
/* product page: open the size chart on this shirt's tab */
(function () {
  const pp = document.querySelector("[data-product-page] .pp-info h1"); if (!pp) return;
  const want = /raffinato/i.test(pp.textContent) ? "raffinato" : "camicia";
  const tab = document.querySelector('.guide-tab[data-guide="' + want + '"]'); if (tab && !tab.classList.contains("active")) tab.click();
})();

/* Bag drawer (2026-10-13): after "Add to bag" the bag slides in with Checkout one tap away,
   instead of a line of text under the button. Built from /cart.js, so it never shows a price
   the store did not compute. The free-shipping line mirrors the store's own rule (orders of $80 or more). */
(function () {
  const FREE = 8000;
  let bag, veil;
  const money = c => "$" + (c / 100).toFixed(2);
  function build() {
    veil = document.createElement("div"); veil.className = "bag-veil"; veil.hidden = true;
    bag = document.createElement("aside"); bag.className = "bag"; bag.setAttribute("role", "dialog"); bag.setAttribute("aria-label", "Your bag"); bag.hidden = true;
    bag.innerHTML = '<div class="bag-head"><strong>Added to your bag</strong><button type="button" class="bag-x" aria-label="Close">×</button></div><div class="bag-items"></div><div class="bag-foot"></div>';
    document.body.append(veil, bag);
    const close = () => { bag.classList.remove("is-open"); veil.classList.remove("is-open"); setTimeout(() => { bag.hidden = veil.hidden = true; }, 300); };
    veil.addEventListener("click", close); bag.querySelector(".bag-x").addEventListener("click", close);
    document.addEventListener("keydown", e => { if (e.key === "Escape" && !bag.hidden) close(); });
  }
  /* The pair (2026-11-02): one shirt is $40 and shipping is free from $80, so the bag offers the
     other shirt in the same collar size. Only when that size is really in stock; no countdown,
     no invented scarcity. Sizes are matched on the inch part ("14.5/ 15 (39cm)" = "14.5/15 (39cm)"). */
  const SHIRTS = { "bamboo-fiber-shirt-non-iron-breathable-fabric": "raffinato-cotton-stretch-dress-shirt",
                   "raffinato-cotton-stretch-dress-shirt": "bamboo-fiber-shirt-non-iron-breathable-fabric" };
  const inch = t => (t || "").split("(")[0].replace(/\s+/g, "");
  async function pairOffer(cart) {
    const handles = [...new Set(cart.items.map(i => i.handle))];
    if (handles.length !== 1 || !SHIRTS[handles[0]]) return "";
    const item = cart.items[0];
    try {
      const other = await (await fetch("/products/" + SHIRTS[handles[0]] + ".js")).json();
      const v = other.variants.find(x => x.available && inch(x.title) === inch(item.variant_title));
      if (!v) return "";
      const name = other.title.replace(/^HADUR /, "").split(" — ")[0];
      const img = other.featured_image ? other.featured_image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
      return `<div class="bag-pair"><p class="bag-pair-k">Complete the pair</p><div class="bag-item">${img ? `<img src="${img}" alt="" width="64" height="80">` : "<span></span>"}<div><b>${name}</b><span>Collar ${v.title} · ${money(v.price)}. Two shirts ship free in Canada.</span></div></div><button type="button" class="btn btn-outline bag-pair-add" data-pair-add="${v.id}">Add the ${name}</button></div>`;
    } catch (e) { return ""; }
  }
  window.hadurOpenBag = async function () {
    const cart = await (await fetch("/cart.js")).json();
    document.querySelectorAll("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
    if (!bag) build();
    bag.querySelector(".bag-items").innerHTML = cart.items.map(i =>
      `<div class="bag-item">${i.image ? `<img src="${i.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2")}" alt="" width="64" height="80">` : "<span></span>"}<div><b>${i.product_title.replace(/^HADUR /, "").split(" — ")[0]}</b><span>Collar ${i.variant_title || ""}${i.quantity > 1 ? " · ×" + i.quantity : ""}</span></div><em>${money(i.final_line_price)}</em></div>`).join("");
    const gap = FREE - cart.total_price;
    const pair = gap > 0 ? await pairOffer(cart) : "";
    bag.querySelector(".bag-items").insertAdjacentHTML("beforeend", pair);
    const pairBtn = bag.querySelector("[data-pair-add]");
    if (pairBtn) pairBtn.addEventListener("click", async () => {
      pairBtn.disabled = true; pairBtn.textContent = "Adding…";
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: Number(pairBtn.dataset.pairAdd), quantity: 1 }] }) });
      if (res.ok) window.hadurOpenBag(); else { pairBtn.textContent = "That size could not be added"; }
    });
    bag.querySelector(".bag-foot").innerHTML =
      (gap > 0 ? `<p class="cart-free">Add <strong>${money(gap)}</strong> more for free shipping in Canada.</p>` : '<p class="cart-free is-on">Orders of $80 or more ship free in Canada.</p>') +
      `<p class="bag-total"><span>Subtotal</span><strong>${money(cart.total_price)}</strong></p><a class="btn btn-dark bag-go" href="/checkout">Checkout</a><a class="bag-view" href="/cart">View bag</a>`;
    bag.hidden = veil.hidden = false;
    requestAnimationFrame(() => { bag.classList.add("is-open"); veil.classList.add("is-open"); });
    return cart;
  };
  // the cart page: a changed quantity updates the bag by itself
  document.querySelectorAll(".cart-form input[name='updates[]']").forEach(inp => inp.addEventListener("change", () => inp.form.querySelector("[data-cart-update]").click()));
})();
